// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1nnoI","rootSmall":"AddTileButton_rootSmall__ED-32"};